import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import React, { useEffect, useState } from 'react';

interface ISearchInputProps extends Omit<TextFieldProps, 'variant'> {
    onSearch?: (value: string) => void;
    width?: number | string;
    startIcon?: React.ReactNode;
    variant?: 'outlined' | 'filled' | 'standard';
    name?: string;

    // mới thêm
    autoSearch?: boolean;     // true = tự động search khi gõ
    resetSignal?: number;     // tăng số này để reset ô search
}

const SearchInput = (props: ISearchInputProps) => {
    const {
        onSearch,
        width = '100%',
        startIcon,
        sx,
        autoSearch = false,
        resetSignal,
        onChange,          // onChange bên ngoài (nếu có)
        placeholder,
        ...rest
    } = props;

    const [value, setValue] = useState('');

    // ===== RESET KHI resetSignal THAY ĐỔI =====
    useEffect(() => {
        if (resetSignal !== undefined) {
            setValue('');
            if (onSearch) {
                // reset luôn kết quả lọc
                onSearch('');
            }
        }
    }, [resetSignal]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const v = e.target.value;
        setValue(v);

        // nếu bật autoSearch thì gõ tới đâu search tới đó
        if (autoSearch && onSearch) {
            onSearch(v);
        }

        // gọi onChange gốc nếu có truyền từ ngoài
        if (onChange) {
            onChange(e);
        }
    };

    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (!autoSearch && e.key === 'Enter' && onSearch) {
            onSearch(value);
        }
    };

    const handleStartIconClick = () => {
        if (!autoSearch && onSearch) {
            onSearch(value);
        }
    };

    return (
        <TextField
            {...rest}
            variant="outlined"
            color="secondary"
            size={props.size ?? 'small'}
            value={value}
            onChange={handleChange}
            onKeyPress={handleKeyPress}
            placeholder={placeholder ?? 'Tìm kiếm...'}
            sx={{
                width,
                borderRadius: '4px',
                ...sx,
            }}
            InputProps={{
                startAdornment: startIcon && (
                    <InputAdornment
                        position="start"
                        sx={{ cursor: 'pointer', paddingLeft: 1, marginRight: 0 }}
                        onClick={handleStartIconClick}
                    >
                        {startIcon}
                    </InputAdornment>
                ),
            }}
        />
    );
};

export default SearchInput;
